export enum IconSize {
  Small = 'sm',
  Medium = 'md',
  Large = 'lg'
}
